module.exports = __webpack_public_path__ + "static/media/ic-single-leg-squat.ea002a07.svg";